<template>
  <div class="edit-workgroup-stage-dailog dialog col-block">
    <customForm
      :init="stage"
      :alerts="alerts"
      :forms="formOptions['field1']"
      @change="(result, validate, errors) => formOnChange('field1', result, validate, errors)"
    ></customForm>
    <div :style="{ height: '20px' }"></div>
    <customForm
      :init="stage"
      :alerts="alerts"
      :forms="formOptions['field2']"
      @change="(result, validate, errors) => formOnChange('field2', result, validate, errors)"
    >
      <template slot="assignee_cover" slot-scope="props">
        <div class="assignee-cover container-block">
          <div v-if="props.result" class="assignee-content-container" v-html="props.form.coverTextDisplay(props.result)"></div>
        </div>
      </template>
    </customForm>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => !onSubmit ? validateSendStage() : ''">
        <span>{{ stage.stage ? $t('COMMON.button.___update') : $t('COMMON.button.___add') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import customForm from '../../components/tool/customForm'
import toastMethods from '../../mixins/toastMethods.vue'

export default {
  components: {
    customForm
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      stages: [],
      stage: {},
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    }
  },
  computed: {
    onError () {
      return Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
    },
    assigneeOptions () {
      let assigneeMap = this.stages.reduce((map, stage) => ({ ...map, [stage.assignee]: stage }), {})
      let noneOptions = [{ title: '- -', value: 'none' }]
      return [
        ...noneOptions,
        ...(this.param.members || []).map(member => {
          let value = [member.first_name, member.last_name].filter(x => x).join(' ') + (' (' + member.email + ')')
          return { title: value, value: value }
        }).filter(option => !assigneeMap[option.value])
      ]
    },
    // static
    formOptions () {
      return {
        field1: [
          {
            title: this.stage.stage ? this.$t('DIALOG.editWorkgroupStage.form.title.___stage') : this.$t('DIALOG.editWorkgroupStage.form.title.___newStage'),
            value: 'stage',
            type: 'input',
            placeholder: () => this.$t('DIALOG.editWorkgroupStage.form.placeholder.___stage'),
            validate: 'required|max:20'
          }
        ],
        field2: [
          {
            title: this.$t('DIALOG.editWorkgroupStage.form.title.___assignee'),
            value: 'assignee',
            type: 'select',
            options: this.assigneeOptions,
            hidden: 'value',
            coverTextDisplay: value => value ? (value !== 'none') ? value.replace(/\(([^()]+)\)/, ' (<span style=color:#006ED6;>$1</span>)') : '- -' : null,
            placeholder: () => this.$t('DIALOG.editWorkgroupStage.form.placeholder.___assignee')
          }
        ]
      }
    }
  },
  created () {
    let stage = this.param.stage || this.stage
    this.stages = (this.param.stages || []).filter(s => s.stage !== stage.stage)
    this.stage = stage
  },
  methods: {
    formOnChange (field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result = {
        ...this.result,
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
      }
      for (let col of cols || Object.keys(this.stage)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    async validateSendStage () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['custom'] = this.customValidate()
      if (!Object.values(result).includes(false)) {
        await this.sendStage()
      }
      this.onSubmit = false
    },
    async sendStage () {
      try {
        if (!this.stages.some(stage => this.result.stage === stage.stage)) {
          let result = {
            ...this.result,
            assignee: (this.result.assignee !== 'none') ? this.result.assignee : ''
          }
          this.$emit('changeModal', {}, result)
        } else {
          throw new Error(this.$t('COMMON.toast.___workgroupStageExist'))
        }
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/editWorkgroupStage.vue